////////////////////////////// Auth //////////////////////////////
export const CHECK_USER_AUTHENTICATED = 'check_user_authenticated';
export const USER_AUTHENTICATED_SUCCESS = 'user_authenticated_success';
export const USER_AUTHENTICATED_FAILURE = 'user_authenticated_failure';
export const LOGIN_USER_EMAIL_PASSWORD = 'login_user_email_password';
export const LOGIN_USER_FAILURE = 'login_user_failure';
export const LOGOUT_USER = 'logout_user';
export const LOGOUT_USER_SUCCESS = 'logout_user_success';
export const CLEAR_AUTH_ERROR = 'clear_auth_error';
export const RESET_USER_PASSWORD = 'reset_user_password';
export const RESET_PASSWORD_REQUEST_STATE = 'reset_password_request_state';
export const EXECUTE_RESET_PASSWORD_FLIGHT = 'execute_reset_password_flight';
export const VERIFY_ACTION_CODE = 'verify_action_code';
export const ACTION_CODE_VALID = 'action_code_valid';
export const ACTION_CODE_INVALID = 'action_code_invalid';
export const RESET_PASSWORD_SUCCESS = 'reset_password_success';
export const RESET_PASSWORD_FAILURE = 'reset_password_failure';
export const UPDATE_AUTH_USER_TOKEN = 'update_auth_user_token';

////////////////////////////// Calls ///////////////////////////////
export const GET_CALLS_COLLECTION = 'get_calls_collection';
export const STORE_CALLS_COLLECTION = 'store_calls_collection';
export const FIELD_PANEL_CALL = 'field_panel_call';
export const END_PANEL_CALL = 'end_panel_call';
export const FIELD_PANEL_CALL_SUCCESS = 'field_panel_call_success';
export const END_PANEL_CALL_SUCCESS = 'end_panel_call_success';
export const FIELD_PANEL_CALL_FAILURE = 'field_panel_call_failure';
export const END_PANEL_CALL_FAILURE = 'end_panel_call_failure';
export const RESUME_PANEL_CALL = 'resume_panel_call';

////////////////////////////// Members /////////////////////////////
export const ADD_NEW_MEMBER = 'add_new_member';
export const ADD_NEW_MEMBER_SUCCESS = 'add_new_member_success';
export const ADD_NEW_MEMBER_FAILURE = 'add_new_member_failure';
export const GET_EXISTING_MEMBER = 'get_existing_member';
export const SET_EXISTING_MEMBER = 'set_existing_member';
export const REMOVE_MEMBERS = 'remove_members';
export const UPDATE_MEMBER = 'update_member';
export const TRANSFER_MEMBER = 'transfer_member';
export const TRANSFER_MEMBER_SUCCESS = 'transfer_member_success';
export const TRANSFER_MEMBER_FAILURE = 'transfer_member_failure';
export const REMOVE_PENDING = 'remove_pending';
export const SUSPEND_PROPERTY_GUEST = 'suspend_property_guest';
export const REMOVE_MEMBER_USER_SUCCESS = 'remove_member_user_success';
export const REMOVE_MEMBER_USER_FAILURE = 'remove_member_user_failure';

/////////////// Member (Manager, Resident, Vendor) //////////
export const ADD_MEMBER = 'add_member';
export const ADD_MEMBER_SUCCESS = 'add_member_success';
export const ADD_MEMBER_FAILURE = 'add_member_failure';
export const RESET_MEMBER_CREATION_STATE = 'reset_member_creation_state';
export const IMPORT_MEMBERS = 'import_members';
export const IMPORT_MEMBERS_SUCCESS = 'import_members_success';
export const IMPORT_MEMBERS_FAILURE = 'import_members_failure';
export const RESET_MEMBER_IMPORT_STATE = 'reset_member_import_state';
export const STORE_UNASSIGNED_DEVICES = 'store_unassigned_devices';
export const FETCH_UNASSIGNED_DEVICES = 'fetch_unassigned_devices';
export const SET_INVITE_PENDING_MEMBERS = 'set_invite_pending_members';
export const RESET_INVITE_PENDING_MEMBERS = 'reset_invite_pending_members';
export const ADD_INVITE_PENDING_MEMBERS = 'add_invite_pending_members';
export const ADD_INVITE_PENDING_MEMBERS_SUCCESS = 'add_invite_pending_members_success';
export const ADD_INVITE_PENDING_MEMBERS_FAILURE = 'add_invite_pending_members_failure';
export const GET_INVITED_MEMBERS_FOR_ORG = 'get_invited_members';
export const GET_INVITED_MEMBERS_FOR_ORG_SUCCESS = 'get_invited_members_success';
export const GET_INVITED_MEMBERS_FOR_ORG_FAILURE = 'get_invited_members_failure';
export const GET_COMMUNITY_MEMBERS_FOR_ORG = 'get_community_members';
export const GET_COMMUNITY_MEMBERS_FOR_ORG_SUCCESS = 'get_community_members_success';
export const GET_COMMUNITY_MEMBERS_FOR_ORG_FAILURE = 'get_community_members_failure';
export const GET_ASSOCIATE_MEMBERS_FOR_ORG_SUCCESS =
    'get_associate_members_for_org_success';
export const GET_ASSOCIATE_MEMBERS_FOR_ORG_FAILURE =
    'get_associate_members_for_org_failure';
export const GET_ORG_GUESTS_FOR_ORG_SUCCESS = 'get_org_guests_for_org_success';
export const GET_ORG_GUESTS_FOR_ORG_FAILURE = 'get_org_guests_for_org_failure';
export const GET_ACCESS_KEYS_DOCUMENT = 'get_access_keys_document';
export const GET_ACCESS_KEYS_DOCUMENT_SUCCESS = 'get_access_keys_document_success';
export const GET_ACCESS_KEYS_DOCUMENT_FAILURE = 'get_access_keys_document_failure';
export const ADD_ACCESS_KEYS_DOCUMENT = 'add_access_keys_document';
export const ADD_ACCESS_KEYS_DOCUMENT_SUCCESS = 'add_access_keys_document_success';
export const ADD_ACCESS_KEYS_DOCUMENT_FAILURE = 'add_access_keys_document_failure';
export const GET_POSTS = 'get_posts';
export const GET_POSTS_SUCCESS = 'get_posts_success';
export const GET_POSTS_FAILURE = 'get_posts_failure';
export const ADD_POST = 'add_post';
export const ADD_POST_SUCCESS = 'add_post_success';
export const ADD_POST_FAILURE = 'add_post_failure';
export const DELETE_POST = 'delete_post';
export const DELETE_POST_SUCCESS = 'delete_post_success';
export const DELETE_POST_FAILURE = 'delete_post_failure';
export const DECLINE_INVITE = 'decline_invite';
export const DECLINE_INVITE_SUCCESS = 'decline_invite_success';
export const DECLINE_INVITE_FAILURE = 'decline_invite_failure';
export const ACCEPT_INVITE = 'accept_invite';
export const ACCEPT_INVITE_SUCCESS = 'accept_invite_success';
export const ACCEPT_INVITE_FAILURE = 'accept_invite_failure';
export const ADD_MEMBERS_FROM_LIST = 'add_members_from_list';
export const CREATE_ACCESS_API_CALL = 'create_access_api_call';
export const CREATE_ACCESS_API_SUCCESS = 'create_access_api_success';
export const CREATE_ACCESS_API_MATCHED_ACCOUNT = 'create_access_api_matched_account';
export const CREATE_ACCESS_API_VERIFY_NUMBER = 'create_access_api_verify_number';
export const CREATE_ACCESS_API_NEW_VERIFICATION = 'create_access_api_new_verification';
export const CREATE_ACCESS_API_NEW_VERIFICATION_ADDED =
    'create_access_api_new_verification_added';
export const CREATE_ACCESS_API_VERIFICATION_SUCCESS =
    'create_access_api_verification_success';
export const CREATE_ACCESS_API_ERROR_MESSAGE = 'create_access_api_error_message';
export const CREATE_ACCESS_API_START_OVER = 'create_access_api_start_over';
export const VALIDATE_SHORT_CODE = 'validate_short_code';
export const SET_SHORT_CODE_VALIDATION_RESULT = 'set_short_code_validation_result';
export const ADVANCE_MEMBER_QUERY = 'advanced_member_query';
export const ADVANCE_MEMBER_QUERY_SUCCESS = 'advanced_member_query_success';
export const ADVANCE_MEMBER_QUERY_FAILURE = 'advanced_member_query_failure';

////////////////////////////// Access Logs ///////////////////////////////
export const FETCH_MORE_LOGS = 'FETCH_MORE_LOGS';
export const UPDATE_ACCESS_LOG = 'UPDATE_ACCESS_LOG';
export const APPEND_ACCESS_LOG = 'APPEND_ACCESS_LOG';
export const MERGE_ACCESS_LOG = 'MERGE_ACCESS_LOG';
export const ACCESS_LOG_ERROR = 'ACCESS_LOG_ERROR';
export const FETCH_ACCESS_LOG_LPR_DOC = 'FETCH_ACCESS_LOG_LPR_DOC';
export const FETCH_ACCESS_LOG_LPR_DOC_SUCCESS = 'FETCH_ACCESS_LOG_LPR_DOC_SUCCESS';
export const FETCH_ACCESS_LOG_LPR_DOC_ERROR = 'FETCH_ACCESS_LOG_LPR_DOC_ERROR';
export const CLEAR_ACCESS_LOG_LPR_DOC = 'CLEAR_ACCESS_LOG_LPR_DOC';
export const FETCH_ACCESS_LOG_DEVICE = 'FETCH_ACCESS_LOG_DEVICE';
export const FETCH_ACCESS_LOG_DEVICE_SUCCESS = 'FETCH_ACCESS_LOG_DEVICE_SUCCESS';
export const FETCH_ACCESS_LOG_DEVICE_ERROR = 'FETCH_ACCESS_LOG_DEVICE_ERROR';
export const CLEAR_ACCESS_LOG_DEVICE = 'CLEAR_ACCESS_LOG_DEVICE';
export const FETCH_ACCESS_LOG_ACCESS_KEY = 'FETCH_ACCESS_LOG_ACCESS_KEY';
export const FETCH_ACCESS_LOG_ACCESS_KEY_SUCCESS =
    'FETCH_ACCESS_LOG_ACCESS_KEY_SUCCESS';
export const FETCH_ACCESS_LOG_ACCESS_KEY_ERROR = 'FETCH_ACCESS_LOG_ACCESS_KEY_ERROR';
export const CLEAR_ACCESS_LOG_ACCESS_KEY = 'CLEAR_ACCESS_LOG_ACCESS_KEY';
export const FETCH_ACCESS_LOG_GUARD_IDENTITY = 'FETCH_ACCESS_LOG_GUARD_IDENTITY';
export const FETCH_ACCESS_LOG_GUARD_IDENTITY_SUCCESS =
    'FETCH_ACCESS_LOG_GUARD_IDENTITY_SUCCESS';
export const FETCH_ACCESS_LOG_GUARD_IDENTITY_ERROR =
    'FETCH_ACCESS_LOG_GUARD_IDENTITY_ERROR';
export const CLEAR_ACCESS_LOG_GUARD_IDENTITY = 'CLEAR_ACCESS_LOG_GUARD_IDENTITY';
export const FETCH_ACCESS_LOG_APPROVER_INVITE = 'FETCH_ACCESS_LOG_APPROVER_INVITE';
export const FETCH_ACCESS_LOG_APPROVER_INVITE_SUCCESS =
    'FETCH_ACCESS_LOG_APPROVER_INVITE_SUCCESS';
export const FETCH_ACCESS_LOG_APPROVER_INVITE_ERROR =
    'FETCH_ACCESS_LOG_APPROVER_INVITE_ERROR';
export const CLEAR_ACCESS_LOG_APPROVER_INVITE = 'CLEAR_ACCESS_LOG_APPROVER_INVITE';

////////////////////////////// Menu ///////////////////////////////
export const SET_ACTIVE_ITEM = 'set_active_menu';
export const SET_ACTIVE_ID = 'set_active_id';
export const SET_ACTIVE_COMPONENT = 'set_active_component';
export const SET_OPEN_DRAWER = 'set_open_drawer';
export const SET_OPEN_COMPONENT_DRAWER = 'set_open_component_drawer';
export const SET_MENU_ERROR = 'set_menu_error';

////////////////////////////// Panels //////////////////////////////
export const GET_PANEL_DATA = 'get_panel_data';
export const SET_PANEL_DATA = 'set_panel_data';
export const GET_ORG_KIOSKS_SUCCESS = 'get_org_kiosks_success';
export const GET_ORG_KIOSKS_FAILURE = 'get_org_kiosks_failure';
export const GET_ORG_PANELS = 'get_org_panels';
export const GET_ORG_PANELS_SUCCESS = 'get_org_panels_success';
export const GET_ORG_PANELS_FAILURE = 'get_org_panels_failure';

////////////////////////////// Org //////////////////////////////
export const GET_ORGS_COLLECTION = 'get_orgs_collection';
export const GET_ORGS_COLLECTION_SUCCESS = 'get_orgs_collection_success';
export const GET_ORGS_COLLECTION_FAILURE = 'get_orgs_collection_failure';
export const GET_USERS_ACTIVE_ORG_COLLECTION = 'get_users_active_org_collection';
export const GET_ACTIVE_ORG_COLLECTION = 'get_active_org_collection';
export const GET_ACTIVE_ORG_COLLECTION_SUCCESS = 'get_active_org_collection_success';
export const GET_ACTIVE_ORG_COLLECTION_FAILURE = 'get_active_org_collection_failure';
export const GET_USER_ORG = 'get_user_org';
export const SET_USER_ORG = 'set_user_org';
export const SET_PRIMARY_ORG = 'set_primary_org';
export const RESET_ORG_CREATION_STATE = 'reset_org_creation_state';
export const SET_SELECTED_ORG = 'set_selected_org';
export const WATCH_SELECTED_ORG = 'watch_selected_org';
export const UPDATE_ORG_IMAGE = 'update_org_image';
export const UPDATE_ORG_IMAGE_SUCCESS = 'update_org_image_success';
export const UPDATE_ORG_IMAGE_FAILURE = 'update_org_image_failure';
export const FETCH_ORG_EXPORT_DATA = 'fetch_org_export_data';

////////////////////////////// Properties //////////////////////////////

export const GET_ORG_PROPERITES_COLLECTION = 'get_org_properties_collection';
export const GET_ORG_PROPERITES_COLLECTION_SUCCESS =
    'get_org_properties_collection_success';
export const GET_ORG_PROPERITES_COLLECTION_FAILURE =
    'get_org_properties_collection_failure';
export const SET_ORGANIZATION_PROPERTY = 'set_organization_property';
export const GET_PROPERTY_BY_ID = 'get_property_by_id';
export const GET_PROPERTY_BY_ID_SUCCESS = 'get_property_by_id_success';
export const GET_PROPERTY_BY_ID_FAILURE = 'get_property_by_id_failure';
export const GET_PROPERTY_MEMBERS_CODES = 'get_property_members_codes';
export const GET_PROPERTY_MEMBERS_CODES_SUCCESS = 'get_property_members_codes_success';
export const GET_PROPERTY_MEMBERS_CODES_FAILURE = 'get_property_members_codes_failure';

////////////////////////////// Reservations /////////////////////////////////

export const ADD_RESERVATION = 'add_reservation';
export const ADD_RESERVATION_SUCCESS = 'add_reservation_success';
export const ADD_RESERVATION_FAILURE = 'add_reservation_failure';
export const RESET_ADD_RESERVATION_STATE = 'reset_add_reservation_state';

export const GET_RESERVATIONS = 'get_reservations';
export const GET_RESERVATIONS_SUCCESS = 'get_reservations_success';
export const GET_RESERVATIONS_FAILURE = 'get_reservations_failure';

export const IMPORT_RESERVATIONS_CSV = 'import_reservations_csv';
export const IMPORT_RESERVATIONS_CSV_FAILURE = 'import_reservations_csv_failure';
export const IMPORT_RESERVATIONS_CSV_SUCCESS = 'import_reservations_csv_success';
export const RESET_IMPORT_RESERVATIONS_STATE = 'reset_import_reservations_state';

export const RESET_RESERVATION_ACTIONS_STATE = 'reset_reservation_actions_state';
export const STORE_GUARD_RESERVATION_ID = 'store_guard_reservation_id';

////////////////////////////// Snackbar //////////////////////////
export const SET_OPEN_SNACKBAR = 'set_open_snackbar';
export const SET_CLOSE_SNACKBAR = 'set_close_snackbar';
export const SET_HANDLER_INCREASE = 'set_handler_increase';
export const SET_HANDLER_DENSE = 'set_handler_dense';
export const SET_HANDLER_ICON_VARIANTS = 'set_handler_icon_variants';

////////////////////////////// User //////////////////////////////
export const GET_USER_COLLECTION = 'get_user_collection';
export const SET_USER_COLLECTION = 'set_user_collection';
export const SET_ACTIVE_USER_ORG = 'set_active_user_org';
export const SET_ACTIVE_USER_ORG_SUCCESS = 'set_active_user_org_success';
export const SET_ACTIVE_USER_ORG_FAILURE = 'set_active_user_org_failure';
export const SET_ACTIVE_USER_PROPERTY = 'set_active_user_property';
export const SET_ACTIVE_USER_PROPERTY_SUCCESS = 'set_active_user_property_success';
export const SET_ACTIVE_USER_PROPERTY_FAILURE = 'set_active_user_property_failure';
export const UPDATE_USER_AVATAR = 'update_user_avatar';
export const UPDATE_USER_AVATAR_SUCCESS = 'update_user_avatar_success';
export const UPDATE_USER_AVATAR_FAILURE = 'update_user_avatar_failure';
export const UPDATE_USER_PROFILE_INFO = 'update_user_profile_info';
export const UPDATE_USER_PROFILE_INFO_SUCCESS = 'update_user_profile_info_success';
export const UPDATE_USER_PROFILE_INFO_FAILURE = 'update_user_profile_info_failure';
export const UPDATE_USER_PROFILE_INFO_RESET = 'update_user_profile_info_reset';

///////////////////////// Intercom ///////////////////////////

export const GET_INTERCOM_COLLECTION = 'get_intercom_collection';
export const STORE_INTERCOM_COLLECTION = 'store_intercom_collection';
export const CREATE_PANEL_INTERCOM = 'create_panel_intercom';
export const CREATE_PANEL_INTERCOM_SUCCESS = 'create_panel_intercom_success';
export const CREATE_PANEL_INTERCOM_FAILURE = 'create_panel_intercom_failure';
export const END_PANEL_INTERCOM = 'end_panel_intercom';
export const END_PANEL_INTERCOM_SUCCESS = 'end_panel_intercom_success';
export const END_PANEL_INTERCOM_FAILURE = 'end_panel_intercom_failure';
export const RESUME_PANEL_INTERCOM = 'resume_panel_intercom';

///////////////////////// Virtual Guard ///////////////////////////
export const GET_PROPERTY_MEMBERS = 'get_property_members';
export const GET_PROPERTY_MEMBERS_SUCCESS = 'get_property_members_success';
export const GET_PROPERTY_MEMBERS_FAILURE = 'get_property_members_failure';
export const GET_INVITED_PROPERTY_MEMBERS_SUCCESS =
    'get_invited_property_members_success';
export const GET_INVITED_PROPERTY_MEMBERS_FAILURE =
    'get_invited_property_members_failure';
export const GET_MEMBER_KEYS = 'get_member_details';
export const GET_MEMBER_KEYS_SUCCESS = 'get_member_keys_success';
export const GET_MEMBER_KEYS_FAILURE = 'get_member_keys_failure';
export const RESET_PROPERTY_MEMBERS = 'reset_property_members';
export const RESET_MEMBER_KEYS = 'reset_member_keys';
export const GET_VG_PROPERTY_BY_ID = 'get_vg_property_by_id';
export const GET_VG_PROPERTY_BY_ID_SUCCESS = 'get_vg_property_by_id_success';
export const GET_VG_PROPERTY_BY_ID_FAILURE = 'get_vg_property_by_id_failure';
export const IMPORT_ORG_PROPERITES = 'import_org_properties';
export const IMPORT_ORG_PROPERITES_SUCCESS = 'import_org_properties_success';
export const IMPORT_ORG_PROPERITES_FAILURE = 'import_org_properties_failure';
export const RESET_IMPORT_ORG_PROPERITES = 'reset_import_org_properties';

////////////////////////////// Otc //////////////////////////////
export const GET_ORG_OTC_CODES = 'get_org_otc';
export const GET_ORG_OTC_SUCCESS = 'get_org_otc_success';
export const RESET_OTC_STATE = 'reset_otc_state';

////////////////////////////// LiveKit //////////////////////////////

export const GENERATE_LIVEKIT_TOKEN = 'generate_livekit_token';
export const GENERATE_LIVEKIT_TOKEN_SUCCESS = 'generate_livekit_token_success';
export const GENERATE_LIVEKIT_TOKEN_FAILURE = 'generate_livekit_token_failure';
export const RESET_LIVEKIT_TOKEN = 'reset_livekit_token';

////////////////////////// Device Operations /////////////////////////
export const GET_PROPERTY_DEVICES_SUCCESS = 'get_property_devices_success';
export const GET_PROPERTY_DEVICES_FAILURE = 'get_property_devices_failure';
export const CHECK_DEVICE_EXISTS = 'check_device_exists';
export const SET_DEVICE_EXISTS_VALIDATION_RESULT = 'set_device_exists_validation_result';

//////////////////////////////// Table ///////////////////////////////
export const SET_PAGE_INDEX = 'set_page_index';
export const SET_ROW_COUNT = 'set_row_count';

//////////////////////////////// CSV Template ///////////////////////////////
export const DOWNLOAD_CSV_TEMPLATE = 'download_csv_template';
export const DOWNLOAD_CSV_TEMPLATE_SUCCESS = 'download_csv_template_success';
export const DOWNLOAD_CSV_TEMPLATE_FAILURE = 'download_csv_template_failure';

//////////////////////////////// Reports ///////////////////////////////
export const FETCH_OCCUPANCY_REPORT = 'fetch_occupancy_report';

//////////////////////////////// Device Types ///////////////////////////////
export const FETCH_DEVICE_TYPES_SUCCESS = 'fetch_device_types_success';
export const FETCH_DEVICE_TYPES_FAILURE = 'fetch_device_types_failure';

//////////////////////////////// Platform Maintenance ///////////////////////////////
export const PLATFORM_MAINTENANCE_ACTIVE = 'PLATFORM_MAINTENANCE_ACTIVE';
export const PLATFORM_MAINTENANCE_INACTIVE = 'PLATFORM_MAINTENANCE_INACTIVE';

//////////////////////////////// Invites V2 ///////////////////////////////
export const GET_ORG_INVITES_V2_SUCCESS = 'GET_ORG_INVITES_V2_SUCCESS';
export const GET_ORG_INVITES_V2_FAILURE = 'GET_ORG_INVITES_V2_FAILURE';

//////////////////////////////// Notifications ///////////////////////////////
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_NOTIFICATIONS_ERROR = 'SET_NOTIFICATIONS_ERROR';
export const SET_NOTIFICATIONS_LAST_READ_AT = 'SET_NOTIFICATIONS_LAST_READ_AT';
export const LOAD_MORE_NOTIFICATIONS = 'LOAD_MORE_NOTIFICATIONS';
export const LOAD_MORE_NOTIFICATIONS_START = 'LOAD_MORE_NOTIFICATIONS_START';
export const LOAD_MORE_NOTIFICATIONS_SUCCESS = 'LOAD_MORE_NOTIFICATIONS_SUCCESS';
export const LOAD_MORE_NOTIFICATIONS_FAILURE = 'LOAD_MORE_NOTIFICATIONS_FAILURE';
export const CLEAR_NOTIFICATIONS_BADGE = 'CLEAR_NOTIFICATIONS_BADGE';
export const MARK_NOTIFICATIONS_READ_REQUEST = 'MARK_NOTIFICATIONS_READ_REQUEST';
export const UPDATE_USER_NOTIFICATIONS_READ_AT = 'UPDATE_USER_NOTIFICATIONS_READ_AT';
export const MARK_NOTIFICATIONS_READ_SUCCESS = 'MARK_NOTIFICATIONS_READ_SUCCESS';

//////////////////////////////// Rentals (Short-Term Rentals > Reservations) ////////////////
export const GET_RENTALS = 'get_rentals';
export const GET_RENTALS_SUCCESS = 'get_rentals_success';
export const GET_RENTALS_FAILURE = 'get_rentals_failure';
export const GET_RENTAL_PROPERTIES = 'get_rental_properties';
export const GET_RENTAL_PROPERTIES_SUCCESS = 'get_rental_properties_success';
export const GET_RENTAL_PROPERTIES_FAILURE = 'get_rental_properties_failure';
export const SET_RENTAL_FILTERS = 'set_rental_filters';
export const RESET_RENTAL_FILTERS = 'reset_rental_filters';

//////////////////////////////// Incident Reports (Guard Reports > Incidents) ////////////////
export const GET_INCIDENT_REPORTS = 'get_incident_reports';
export const GET_INCIDENT_REPORTS_SUCCESS = 'get_incident_reports_success';
export const GET_INCIDENT_REPORTS_FAILURE = 'get_incident_reports_failure';
export const SET_INCIDENT_REPORT_FILTERS = 'set_incident_report_filters';
export const RESET_INCIDENT_REPORT_FILTERS = 'reset_incident_report_filters';
